import React from "react";
import { useParams } from "react-router-dom";

import { Layout } from "scenes/Authentication/components";
import { useUserInvite } from "scenes/Authentication/hooks";

import { Loading, SignUpForm } from "./components";

function SignUpInvitation() {
  const { advisorId } = useParams();
  const { loading, email, errorMessage } = useUserInvite(advisorId);

  if (loading && !errorMessage) {
    return (
      <Loading
        active
        messages={["Processing invite...", "Processing invite..."]}
      />
    );
  }

  if (errorMessage) {
    return <Layout errorMessage={errorMessage} />;
  }

  return <SignUpForm email={email} />;
}

export default SignUpInvitation;
